import React from "react";
import packageInfo from "../../package.json"; // 根據您的目錄結構調整路徑

const usePackageVersion = () => {
  return `v${packageInfo.version || "0.0.0"}`;
};

export default usePackageVersion;
